import React, { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {
  css,
  Link,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { FC } from 'react';

import { Milestone } from '@features/accountCompletion';
import { successGreen, white } from '@styles/colors';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useNavigate } from 'react-router-dom';

type MilestonesListProps = {
  milestones: Milestone[];
};

const MilestonesList: FC<MilestonesListProps> = ({ milestones }) => {
  const theme = useTheme();
  const navigate = useNavigate()
  const [hoveredItemId, setHoveredItemId] = useState<number | null>(null);

  return (
    <Stack
      marginTop={4}
      marginBottom={6}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 3,
        flexWrap: 'wrap',
      }}
    >
      {milestones.map(
        ({ label, description, subproperties, complete, id, url }) => (
          <ListItem
            key={id}
            onMouseEnter={() => setHoveredItemId(id)}
            onMouseLeave={() => setHoveredItemId(null)}
            onClick={() => navigate(url)}
            sx={{
              flex: '1 1 calc(50% - 8px)',
              border: `2px solid ${complete ? successGreen : theme.palette.secondary.main}`,
              borderRadius: theme.shape.customBorderRadius.medium,
              padding: '15px 20px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%',
              alignItems: 'flex-start',
              position: 'relative',
              '@media (max-width: 600px)': {
                flex: '1 1 100%',
              },
              transition: 'all 0.3s ease',
              '&:hover': {
                cursor: 'pointer',
              },
            }}
          >
            <CheckCircleRoundedIcon
              sx={{
                color: complete ? successGreen : theme.palette.secondary.main,
                fontSize: '28px',
                position: 'absolute',
                right: '-12px',
                top: '-12px',
                backgroundColor: white,
                borderRadius: '50%',
              }}
            />
            <ListItemText
              primary={
                <Typography
                  // href={url}

                  sx={{
                    color: complete ? successGreen : theme.palette.secondary.main,
                    textDecoration: 'none',
                    fontSize: '16px',
                    fontWeight: 600,
                  }}
                >
                  {label}
                </Typography>
              }
              secondary={
                <>
                  <div
                    style={{
                      maxHeight: hoveredItemId === id ? '200px' : '0',
                      opacity: hoveredItemId === id ? 1 : 0,
                      overflow: 'hidden',
                      transition: 'max-height 0.4s linear',
                    }}
                  >
                    {subproperties ? (
                      subproperties.map((subproperty) => (
                        <span key={subproperty.id} style={{ marginTop: "2px" }}>
                          {subproperty.complete ? (
                            <CheckIcon
                              sx={{
                                fontSize: '14px',
                                marginRight: '2px',

                                color: successGreen,
                                verticalAlign: 'middle',
                              }}
                            />
                          ) : (
                            <CloseIcon
                              sx={{
                                fontSize: '14px',
                                marginRight: '2px',
                                verticalAlign: 'middle',
                                color: theme.palette.secondary.main,
                              }}
                            />
                          )}
                          {subproperty.label}
                        </span>
                      ))
                    ) : (
                      description
                    )}
                  </div>
                </>
              }
            />

          </ListItem>
        )
      )}
    </Stack>
  );
};

export default MilestonesList;
